import API_URLS from "@constants/api.urls";

import {
  DeletedProjectsIcon,
  ExampleProjectIcon,
  FilesIcon,
  FolderIcon,
  ImportedProjectsIcon,
  SharedProjectIcon,
  StarIcon,
} from "@components/SVGs";
import HomeIcon from "@components/SVGs/HomeIcon";

export const HomeSideNavIds = {
  home: "home",
  allProjects: "all_projects",
  favProjects: "favourite_projects",
  importedProjects: "imported_projects",
  sharedProjects: "shared_projects",
  exampleProjects: "example_projects",
  deleted: "deleted_items",
  folders: "folders",
  folderProject: "folderProject",
};

export const HomeSideNavMenu = t => [
  {
    id: HomeSideNavIds.home,
    label: t("sideNavOptions.home"),
    active: true,
    icon: <HomeIcon />,
  },
  {
    id: HomeSideNavIds.allProjects,
    label: t("sideNavOptions.allProjects"),
    active: true,
    icon: <FilesIcon />,
  },
  {
    id: HomeSideNavIds.favProjects,
    label: t("sideNavOptions.favouriteProjects"),
    active: true,
    icon: <StarIcon />,
  },
  {
    id: HomeSideNavIds.importedProjects,
    label: t("sideNavOptions.importtedProjects"),
    active: true,
    icon: <ImportedProjectsIcon />,
  },
  {
    id: HomeSideNavIds.exampleProjects,
    label: t("sideNavOptions.exampleProjects"),
    active: true,
    icon: <ExampleProjectIcon />,
  },
  {
    id: HomeSideNavIds.sharedProjects,
    label: t("sideNavOptions.sharedProjects"),
    active: true,
    icon: <SharedProjectIcon />,
  },
  {
    id: HomeSideNavIds.deleted,
    label: t("sideNavOptions.deletedProjects"),
    active: true,
    icon: <DeletedProjectsIcon />,
  },
  {
    id: HomeSideNavIds.folders,
    label: t("sideNavOptions.folders"),
    active: true,
    icon: <FolderIcon />,
  },
];
export const HomeSidNavUrlMapping = {
  [HomeSideNavIds.home]: API_URLS.recentProjects,
  [HomeSideNavIds.allProjects]: API_URLS.allProjects,
  [HomeSideNavIds.favProjects]: API_URLS.projectFavorite,
  [HomeSideNavIds.exampleProjects]: API_URLS.exampleProject,
  [HomeSideNavIds.sharedProjects]: API_URLS.shareProject,
  [HomeSideNavIds.deleted]: API_URLS.projectDeleted,
  [HomeSideNavIds.folderProject]: API_URLS.folderProject,
  [HomeSideNavIds.importedProjects]: API_URLS.allProjects,
};

export const FoldersBreadcrumbData = t => [
  {
    id: HomeSideNavIds.home,
    label: t("sideNavOptions.home"),
  },
  {
    id: HomeSideNavIds.folders,
    label: t("sideNavOptions.folders"),
  },
];
